import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TOURNAMENT_PAGE_STATS_GENERATION_FETCH = 'TOURNAMENT_PAGE_STATS_GENERATION_FETCH'
export const TOURNAMENT_PAGE_STATS_GENERATION_FETCH_ERROR = 'TOURNAMENT_PAGE_STATS_GENERATION_FETCH_ERROR'
export const TOURNAMENT_PAGE_STATS_GENERATION_FETCH_FULFILLED = 'TOURNAMENT_PAGE_STATS_GENERATION_FETCH_FULFILLED'
export const TOURNAMENT_PAGE_STATS_GENERATION_FETCH_CANCELED = 'TOURNAMENT_PAGE_STATS_GENERATION_FETCH_CANCELED'

export const tournamentStatsGenerationFetch = (tournamentId, name) => ({
  notification: {
    id: tournamentId,
    children: `Generando estadísticas para "${name}".`,
    dismissAfter: 20000,
  },
  payload: { name, tournamentId },
  type: TOURNAMENT_PAGE_STATS_GENERATION_FETCH,
})

export const tournamentStatsGenerationFetchFulfilled = (payload) => ({
  notification: {
    id: payload.originalAction.payload.tournamentId,
    children: 'Las nuevas estadísticas estarán disponibles en 10 minutos.',
  },
  payload,
  type: TOURNAMENT_PAGE_STATS_GENERATION_FETCH_FULFILLED,
})

export const tournamentStatsGenerationFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PAGE_STATS_GENERATION_FETCH_CANCELED,
})

export const tournamentStatsGenerationFetchError = (payload) => ({
  notification: {
    id: payload.originalAction.payload.tournamentId,
    children: payload.error.msg || 'No es posible generar las estadísticas.',
  },
  payload,
  type: TOURNAMENT_PAGE_STATS_GENERATION_FETCH_ERROR,
})

export const tournamentStatsGenerationFetchEpic = (action$) =>
  action$.pipe(
    ofType(TOURNAMENT_PAGE_STATS_GENERATION_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/tournament/${action.payload.tournamentId}/stats`, action).pipe(
        map(epicResponseHandler(tournamentStatsGenerationFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TOURNAMENT_PAGE_STATS_GENERATION_FETCH_CANCELED))),
        catchError(epicErrorHandler(tournamentStatsGenerationFetchError, action)),
      ),
    ),
  )
